import tw from "twin.macro"
import { withFocusRing } from "../FocusRing/FocusRing"

export const SkipLink = withFocusRing(tw.a`
  fixed -top-peta -left-peta z-100 px-3 py-midi text-white bg-warning focus-visible:!outline-warning focus:top-midi focus:left-midi
`)
